export interface IUnitPrice {
  amount: number;
  price: number;
  unit: EUnit;
}

export enum EUnit {
  PACKAGE = 'Package',
  PIECES = 'Pieces',
  GRAMS = 'Grams',
  MILLILITERS = 'Milliliters',
  CENTIMETERS = 'Centimeters',
  METERS = 'Meters',
}
